<template>
  <div class="w-1/2 mx-auto">
    <label>
      File
      <input
        class="w-full"
        type="file"
        id="file"
        ref="file"
        v-on:change="onChangeFileUpload()"
      />
    </label>
    <br />
    <div class="w-full mx-auto pt-4">
      <vs-button v-on:click="submitForm()">Upload</vs-button>
    </div>
    <div v-if="bverify" class="w-full mx-auto pt-4">
      <vs-input disabled class="inputx w-full" v-model="filename" />
      <div class="pt-4">
        <vs-button @click="onbverify">Verify</vs-button>
        <vs-progress v-if="progress" indeterminate color="primary"
          >primary</vs-progress
        >
      </div>
    </div>
    <div v-if="verify" class="w-full mx-auto pt-4">
      <vs-input
        v-if="verify"
        class="inputx w-1/2 pt-4"
        v-model="declaration"
        label-placeholder="Declaration Number"
      />
      <vs-input
        v-if="verify"
        class="inputx w-1/2 pt-4"
        v-model="depdate"
        v-mask="'####-##-##'"
        label-placeholder="Declaration Date"
      />
      <br />
      <b-table :data="data" :columns="columns"></b-table>

      <div class="pt-4">
        <vs-button @click="onverify">Confirm</vs-button>
        <vs-progress v-if="progress" indeterminate color="primary"
          >primary</vs-progress
        >
      </div>
    </div>
    <br />
    <inberror
      v-if="errorshow"
      :key="errorshow"
      :errdata="errdata"
      :declaration="declaration"
      :depdate="depdate"
      :filename="filename"
      @done="uploadDone"
    ></inberror>
  </div>
</template>
<style scoped>
img {
  max-height: 36px;
}
</style>
<script>
import axios from "axios";
import { BASE_API_URL } from "@/constants/index.ts";
import inberror from "./inberror.vue";

export default {
  data() {
    return {
      userid: "",
      companyGroupsCode: "",
      errorshow: false,
      file: "",
      bverify: false,
      verify: false,
      progress: false,
      filename: null,
      declaration: null,
      depdate: null,
      hawb: null,
      data: [],
      columns: [
        {
          field: "item",
          label: "Item",
          width: "40",
          numeric: true,
        },
        {
          field: "hbl",
          label: "HouseBl",
        },
        {
          field: "qty",
          label: "TotalPackage",
          width: "40",
          numeric: true,
        },
        {
          field: "qtyunit",
          label: "Unit",
          centered: true,
        },
      ],
    };
  },
  methods: {
    uploadDone() {
      let vm = this;
      // alert("Done");
      vm.$emit("done");
    },
    async onbverify() {
      let vm = this;
      let formData = new FormData();
      formData.append("file", this.file);
      formData.append("filename", this.filename);
      formData.append("editor", String(this.userid));
      formData.append("companyGroupsCode", this.companyGroupsCode);

      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        const response = await axios.post(
          `${BASE_API_URL}/outbound-svc/exborders/fuploadDOM`,
          formData,
          {
            headers: { Authorization: "Bearer " + token.accessToken },
          }
        );

        // console.log(res.data.message);
        if (response.data.status != "success") {
          vm.$vs.notify({
            title: "Upload",
            text: response.data.message,
            color: "danger",
            position: "top-right",
            fixed: true,
          });
        } else {
          vm.$vs.notify({
            title: "Verify",
            text: "Verify Complete",
            color: "success",
            position: "top-right",
            time: 3000,
          });

          if (response.data.message != undefined) {
            // console.log(response.data)
            vm.declaration = response.data.message;
            vm.depdate = response.data.depdate;
            vm.data = response.data.data;
          } else {
            vm.declaration = "";
            vm.depdate = "";
          }
          vm.verify = true;
        }
        vm.progress = false;
      } catch (err) {
        // console.log(err);
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }
    },
    async onverify() {
      let vm = this;
      // console.log(this.declaration);
      if (this.declaration == "" || this.depdate == "" || this.hawb == "") {
        vm.$vs.notify({
          title: "Upload",
          text: "Please Enter Complete Information",
          color: "danger",
          position: "top-right",
          time: 3000,
        });
      } else if (this.declaration.length > 13) {
        vm.$vs.notify({
          title: "Upload",
          text: "Not Allow Reference Number more than 13 digit",
          color: "danger",
          position: "top-right",
          fixed: true,
        });
        return;
      } else {
        this.progress = true;

        try {
          const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

          if (token) {
            const formData = {
              filename: this.filename,
              declaration: this.declaration,
              depdate: this.depdate,
              hawb: this.hawb,
              editor: String(this.userid),
              companyGroupsCode: this.companyGroupsCode,
              businessPartnersCode: this.businessPartnersCode,
            };

            const response = await axios.post(
              `${BASE_API_URL}/outbound-svc/exborders/uploadDOM`,
              formData,
              {
                headers: { Authorization: "Bearer " + token.accessToken },
              }
            );

            if (response.data.status != "success") {
              this.loading = false;
              this.$vs.notify({
                position: "top-right",
                color: "danger",
                title: "Error from Backend",
                text: response.data.message,
                fixed: true,
              });
            } else {
              if (this.$store.state.reportgrid == 0) {
                this.$store.dispatch("setReportGrid", 1);
              } else {
                this.$store.dispatch("setReportGrid", 0);
              }

              this.$vs.notify({
                position: "top-right",
                color: "success",
                title: "Upload Complete",
                text: response.data.message,
              });
            }
            vm.progress = false;
            vm.$emit("done");
          }
        } catch (error) {
          this.data = [];
          this.total = 0;
          this.loading = false;
          // throw error;
          alert("กรุณาเข้าระบบอีกครั้ง");
          // this.$router.replace("/pages/login/");
        }
      }
    },
    async submitForm() {
      let vm = this;
      // console.log(this.file['name'])
      // console.log(this.filename)
      let file = this.filename;
      let files = file.split(".");
      let filename = files[1];

      if (filename != "xml") {
        vm.$vs.notify({
          title: "Upload",
          text: "อนุญาติเฉพาะไฟล์ XML",
          color: "danger",
          position: "top-right",
          fixed: true,
        });
      } else {
        vm.$vs.notify({
          title: "Upload",
          text: "อนุญาติให้ Upload",
          color: "success",
          position: "top-right",
          time: 3000,
        });
        vm.bverify = true;
      }
    },

    onChangeFileUpload() {
      this.file = this.$refs.file.files[0];
      this.filename = this.$refs.file.files[0].name;
    },
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        const decoded = JSON.parse(
          Buffer.from(token.accessToken.split(".")[1], "base64").toString()
        );

        // console.log(decoded);

        try {
          // console.log(response.data);
          this.userid = decoded.userId;
          this.userRole = decoded.userRole;

          this.businessPartnersCode = decoded.businessPartnersCode;
          this.companyGroupsCode = decoded.companyGroupsCode;
        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/");
        }
      } else {
        alert("กรุณาเข้าระบบอีกครั้ง");
        await this.$router.replace("/");
      }
    },
  },
  components: {
    inberror,
  },
  mounted() {
    this.checkProfiles();
    // console.log(this.$acl.check('admin'));
  },
};
</script>
